import { BRAZIL_STATE_MINI_PATHS, BRAZIL_STATE_PATHS } from '../constants/brazilStatePaths';
import { ALL_STATE_CODES } from '../constants/parameters.constants';

export const isBrazilMapAvailable = ALL_STATE_CODES.every(
	(code) => !!BRAZIL_STATE_PATHS[code] && !!BRAZIL_STATE_MINI_PATHS[code]
);
